const BianxinIntro = resolve => {
    import(/* webpackChunkName: 'bianxinIntro' */'../views/bianxian/intro').then(bianxinIntro => {
        resolve(bianxinIntro)
    })
}

const BianxianBidcountIntro = resolve => {
    import(/* webpackChunkName: 'bianxianBidcountIntro' */'../views/bianxian/bidcountIntro').then(bianxianBidcountIntro => {
        resolve(bianxianBidcountIntro)
    })
}

const BianxianfwfIntro = resolve => {
    import(/* webpackChunkName: 'bianxianfwfIntro' */'../views/bianxian/fwfIntro').then(bianxianfwfIntro => {
        resolve(bianxianfwfIntro)
    })
}

const BianxianLevelExplainIntro = resolve => {
    import(/* webpackChunkName: 'bianxianLevelExplainIntro' */'../views/bianxian/levelExplainIntro').then(bianxianLevelExplainIntro => {
        resolve(bianxianLevelExplainIntro)
    })
}

const BianxianRebateIntro = resolve => {
    import(/* webpackChunkName: 'bianxianRebateIntro' */'../views/bianxian/rebateIntro').then(bianxianRebateIntro => {
        resolve(bianxianRebateIntro)
    })
}

export default [
    {
        path: '/bianxian/intro',
        name: 'bianxinIntro',
        component: BianxinIntro,
        meta: {
            title: '拍拍贷'
        }
    },
    {
        path: '/bianxian/bidcountIntro',
        name: 'bianxianBidcountIntro',
        component: BianxianBidcountIntro,
        meta: {
            title: '拍拍贷'
        }
    },
    {
        path: '/bianxian/fwfIntro',
        name: 'bianxianfwfIntro',
        component: BianxianfwfIntro,
        meta: {
            title: '拍拍贷'
        }
    },
    {
        path: '/bianxian/levelExplainIntro',
        name: 'bianxianLevelExplainIntro',
        component: BianxianLevelExplainIntro,
        meta: {
            title: '拍拍贷'
        }
    },
    {
        path: '/bianxian/rebateIntro',
        name: 'bianxianRebateIntro',
        component: BianxianRebateIntro,
        meta: {
            title: '拍拍贷'
        }
    }
]
